import { FORM_ERROR_MESSAGE_CLASS, useTranslation } from '@wix/form-fields';
import { Error } from '@wix/wix-ui-icons-common/on-stage';
import classNames from 'classnames';
import React from 'react';
import { TRANSLATIONS_NAMESPACE } from '../../constants/translations';
import { DATA_HOOKS } from '../../tpa/widget/data-hooks';
import styles from './submit-status-message.module.scss';
const ERROR_MESSAGE_KEY = 'submit.failed.message';
export const SubmitErrorMessage = ({ errorMessageCode, errorMessage, forced })=>{
    const { t, i18n } = useTranslation();
    if (!errorMessageCode && !errorMessage && !forced) {
        return null;
    }
    const errorMessageKeyByCode = `${ERROR_MESSAGE_KEY}.${errorMessageCode}`;
    const errorMessageKey = i18n.exists(`${TRANSLATIONS_NAMESPACE}:${errorMessageKeyByCode}`) ? errorMessageKeyByCode : ERROR_MESSAGE_KEY;
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames(FORM_ERROR_MESSAGE_CLASS, styles.errorMessageContainer)
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.errorMessage,
        "data-hook": DATA_HOOKS.SUBMIT_ERROR_MESSAGE
    }, /*#__PURE__*/ React.createElement(Error, {
        className: styles.errorIcon,
        "aria-hidden": "true"
    }), errorMessage || t(errorMessageKey)));
};

//# sourceMappingURL=submit-error-message.js.map